import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom'

import {
  Typography,
  Checkbox,
  FormControlLabel,
  useMediaQuery,
  CircularProgress,
  Box,
  Grid,
  styled, useTheme
} from '@mui/material'
import LocationOnIcon from "@mui/icons-material/LocationOn"
// import { Document, Page } from "react-pdf"
import { FormatColorResetTwoTone } from "@mui/icons-material"

//import { mainStyles, theme } from "../../styles/Main.js"
import {
  CustomLoadingOverlay, LocationDialogComponent,
  GenericContainer, CustomAlertMaterial
  , Buttons
} from "../../components"
import VisorPDF from "../../components/Visor/VisorPDF";
import { documentsActions, fileActions, workflowActions } from "../../store/actions"
import { useStyles } from "./DocumentSignStyles"
import { b64toUrl, coreFunctions } from '../../utils';
import { useTranslation } from 'react-i18next';

const LabelCustom = styled(FormControlLabel)(({ theme }) => ({
  margin: '0px !important',
  "& .MuiFormControlLabel-root": {
    margin: '0px !important'
  },
  "& .PrivateSwitchBase-root": {
    padding: '5px !important'
  },
  "label": {
    margin: '0px !important'
  }
}));


export default function DocumentViewerCheck(props) {
  const matches = useMediaQuery('(max-width:812px)')
  const { useState, useEffect } = React;
  const gridContainer = {} //mainStyles.gridStyle();
  const localStyles = useStyles();
  const navigate = useNavigate();
  const theme = useTheme()
  const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()//estílos genéricos (Main.js)

  const [currentStage, setCurrentStage] = useState(0);
  const [totalStage, setTotalStage] = useState(0);
  const [stageName, setStageName] = useState("");
  const [docTypes, setDocTypes] = useState({});
  const [response, setResponse] = useState("");
  const [checkState, setCheckState] = useState(false);
  const [openLocation, setOpenLocation] = useState(false);
  const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader 
  const [isOneList, setIsOneList] = useState(false);
  const [fileUrl, setfileUrl] = useState(null);
  const [loadFileInfo, setLoadFileInfo] = useState(false);
  const { t } = useTranslation();

  const [cancelAlert, setCancelAlert] = useState(false)
  const [cancelAction, setCancelAction] = useState(false)

  //Redux hooks
  const auth = useSelector((state) => state.Authentication)
  const file = useSelector((state) => state.FileInfo)
  // const wf = useSelector((state) => state.Workflow);
  const pdfDoc = useSelector((state) => state.Document)
  const cancelWF = useSelector(state => state.CancelWorkFlow)

  const dispatch = useDispatch();

  useEffect(() => {
    console.log("location.state", location.state)
    setfileUrl(null);
    dispatch(documentsActions.DownloadDocument(props.location.state.documentTypes?.Document?.Id));
    dispatch(fileActions.GetFileInfo(location.state.folioId));
    setIsOneList(location.state.oneList)
    setLoadFileInfo(true)
    setLoadView(true)
  }, []);

  useEffect(() => {
    if (file.items != undefined && file.error != null && loadFileInfo) {
      console.log("file.items: ", file.items)
      getStageProperties(file.items);
      setLoadView(false)
      setLoadFileInfo(false)
    } else if (file.error != undefined && file.error != null && loadFileInfo) {
      setLoadView(false)
      setLoadFileInfo(false)
    }
  }, [file]);

  useEffect(() => {
    if (cancelWF.items != undefined && cancelAction) {
      setLoadView(false)
      console.log("cancelWF.items*********************: ", cancelWF.items)
      if (cancelWF.items?.Stage != null) {
        let nextStage = cancelWF.items?.Stage
        let stageName = nextStage.Name
        let stageId = nextStage.Id
        let folioId = file.items.Id
        let stage = cancelWF.items?.Stage

        let nextComponent = coreFunctions.GetLegoNext(stageName)
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })

      }
    }
  }, [cancelWF])


  useEffect(async () => {
    if (pdfDoc.items != undefined) {
      setfileUrl(null);
      let pdfB64 = pdfDoc.items.B64Content;
      if (pdfB64 != undefined && pdfB64 != null) {
        let mimeType = 'application/pdf'
        // const blob = await B64toBlobAsync(pdfB64, mimeType);
        // console.log("Blob generado: ", blob)
        const blobUrl = b64toUrl(pdfB64) //URL.createObjectURL(blob);
        console.log("URL Blob: ", blobUrl)
        setfileUrl(blobUrl);
        setLoadView(false)
      }
    }
  }, [pdfDoc]);

  let getStageProperties = (element) => {
    let stageName = element.Stage.Name;
    let stageId = element.Stage.Id;

    setDocTypes(props.location.state.documentTypes);
    setStageName(props.location.state.documentTypes.Name);
    setTotalStage(element.Stage.TotalStageGroups);
    setCurrentStage(element.Stage.CurrentStageGroup);
  };

  let handleRejectDocument = () => {
    let nextStage = (location.state.stage.Stage === undefined ? location.state.stage : location.state.stage.Stage)
    let stageName = nextStage.Name
    let stageId = nextStage.Id
    let folioId = location.state.folioId
    let stage = (location.state.stage.Stage === undefined ? location.state.stage : location.state.stage.Stage)
    let isRejected = true
    let documentId = docTypes.Id

    let nextComponent = "DocumentSignComponent"
    coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId, documentId, isRejected } })

  };

  let handleAcceptDocument = () => {
    if (isOneList) {
      let nextStage = file.items.Stage
      let stageName = nextStage.Name
      let stageId = nextStage.Id
      let folioId = file.items.Id
      let stage = file.items.Stage
      let nextComponent = "SignHelp"

      console.log("{ auth ,navigate,nextComponent, stageName, stageId, stage, folioId }: ", { navigate, nextComponent, stageName, stageId, stage, folioId })
      coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
    } else {
      let nextStage = (location.state.stage.Stage === undefined ? location.state.stage : location.state.stage.Stage)
      let stageName = nextStage.Name
      let stageId = nextStage.Id
      let folioId = location.state.folioId
      let stage = (location.state.stage.Stage === undefined ? location.state.stage : location.state.stage.Stage)
      let isRejected = false
      let documentId = docTypes.Id

      let nextComponent = "DocumentSignComponent"
      coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId, documentId, isRejected } })
    }
  };

  let handleCheckChange = (e) => {
    setCheckState(e.target.checked);
  };

  let handleLocationButton = () => {
    setOpenLocation(true)
    // props.navigate({
    //   pathname: "LocationSignComponent",
    // });
  }
  let handleLocationButtonClose = () => {

    setOpenLocation(false)
  }

  return (<GenericContainer>
    <Typography variant="h6">
      Contrato
    </Typography>
    <Typography variant="subtitle1" >
      {t("legal_read")}
    </Typography>
    <Box sx={{ display: 'flex', maxWidth: '100%', height: matches ? '53vh' : '50vh' }}>
      {navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i)
        || matches && fileUrl != null ?
        <VisorPDF pdfUrl={fileUrl} />
        : <object width="100%" height="100%" data={fileUrl} type='application/pdf' />
      }
    </Box>
    <Box sx={{
      display: 'flex', justifyContent: 'center',
      flexDirection: 'column', width: '100%', alignItems: 'center',
      marginTop: 15, marginBottom: 34, paddingBottom: 34
    }}>
      <LabelCustom
        value={"TextCheck"}
        control={
          <Checkbox
            color="primary"
            onChange={handleCheckChange}
            value={"TextCheck"}
          />
        }
        label={
          <Typography variant="subtitle2" >
            {t("legal_read_auth")}
          </Typography>
        }
        labelPlacement="end"
      />
      <Buttons disabledConfirm={checkState ? false : true}
        ConfirmButtonText={t("general_accept")}
        onClickConfirm={handleAcceptDocument}
        /* CancelButtonText={t("general_cancel")}
        onClickCancel={() => {
          setCancelAlert(true)
        }} */
      />
    </Box>

    <LocationDialogComponent open={openLocation} closeAction={handleLocationButtonClose} />

    {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}

    {cancelAlert &&
      <CustomAlertMaterial
        title={t("autograph_signature")}
        body={t("applicant_on_cancel")}
        closeAction={() => setCancelAlert(false)}
        open={cancelAlert}
        leftButtonText={t("general_cancel")}
        leftButtonAction={() => setCancelAlert(false)}
        rightButtonText={t("general_accept")}
        rightButtonAction={() => {
          setCancelAction(true)
          setLoadView(true)
          dispatch(workflowActions.CancelWorkFlow({ File_Id: file.items.Id }))
        }}
      />
    }
  </GenericContainer>);
}
